import * as React from "react";

import { Alert, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";

import { Workflow } from "src/domain/core/workflow/components/create/Workflow";

interface LauncherProps {
  blueprints: Array<WorkflowBlueprintDesc>;
  disabled: boolean;
  nodes: Nodes;
  instancesError: Error;
  disks: Disk[];
  disksError: Error;
  templates: Templates;
}

export const Launcher: React.FC<LauncherProps> = ({
  blueprints,
  disabled,
  nodes,
  instancesError,
  disks,
  disksError,
  templates,
}) => {
  const sortedBlueprints = React.useMemo(() => {
    // Calling 'sort' alters the original reference, and we don't want to alter props.
    const blueprintsCopy = blueprints ? blueprints.slice() : [];

    // Return - if a should come first
    // Return + if b should come first
    // Return 0 if they are the same
    // We want <recent dates> (bigger numbers) to come first.
    return blueprintsCopy.sort((a, b) => {
      const dateA = Date.parse(a.created_at);
      const dateB = Date.parse(b.created_at);

      return dateB - dateA;
    });
  }, [blueprints]);

  if (instancesError) {
    return (
      <Alert data-testid="workflow-launcher-alert" severity="warning">
        There was a problem preparing workflow blueprints for launch. Please try refreshing the page. If the problem
        persists, please contact support.
      </Alert>
    );
  }

  if (sortedBlueprints && sortedBlueprints.length > 0) {
    return (
      <Stack data-testid="workflow-launcher">
        {sortedBlueprints.map((blueprint) => {
          return (
            <Workflow
              key={blueprint.id}
              {...blueprint}
              disabled={disabled}
              nodes={nodes}
              blueprints={blueprints}
              disks={disks}
              disksError={disksError}
              templates={[...(templates?.user || [])]}
            />
          );
        })}
      </Stack>
    );
  }

  return (
    <Typography data-testid="workflow-launcher" style={{ margin: "200px 0px", textAlign: "center" }}>
      No workflow blueprints available
    </Typography>
  );
};
